import { apiSecureRequest } from '@utils/request';
import { DebtOffering } from 'types/debt-offerings';
import moment from 'moment';

export async function getActiveDebtOfferings(): Promise<Array<DebtOffering>> {
	const response = await apiSecureRequest.get(`/debt-offerings`);
	response.data.forEach((debtOffering: DebtOffering) => {
		debtOffering.maturityDate = moment(debtOffering.maturityDate).format('MMM D, YYYY');
		debtOffering.achTransactionDate = moment(debtOffering.achTransactionDate).format('MMM D, YYYY');
	});
	return response.data;
}
